import React from "react";
import { styleBlock } from "../styleBlock";
const HeaderRow = ({ className, size, children, title, level = 1, id, useSpan }) => {
    const headingElement = React.createElement(useSpan ? "span" : `h${level}`, { id: id }, title);
    const cn = styleBlock("header-row");
    const headingClass = size ? `header-row--size-${size}` : "";
    return (React.createElement("div", { className: cn.mix(["row", "align-items-center", "justify-content-between", headingClass]).mix(className) },
        React.createElement("div", { className: "col" }, headingElement),
        children && React.createElement("div", { className: "col-auto" }, children)));
};
HeaderRow.defaultProps = {
    level: 1,
};
export default HeaderRow;
//# sourceMappingURL=index.js.map